export default "__VITE_ASSET__HrWkS5cq__"